import { UNAUTHORIZED } from 'http-status-codes';
import { USER_FOUND, USER_EXPIRED } from 'redux-oidc';
import {
  AUTHORIZED,
  LOGIN_PROFILE,
  LOGIN_SUCCESS,
  LOGIN_REFRESH,
  LOGIN_FAILURE,
  NO_USER,
  SELECTED_DATE_UPDATE,
  OIDC_SESSION_TERMINATED,
} from '../actions/constants/types';
import axios from '../utils/axios';
import globals from '../globals/communityGlobals';
import { parseDateUtc } from '../utils/dates';

const locale = globals.getArea('accountLogin');

function loginErrorHandling(errorResponse) {
  let error = '';
  if (errorResponse.response) {
    if (errorResponse.response.status === UNAUTHORIZED) {
      const { translationKey } = errorResponse.response.data || { translationKey: '' };
      if (translationKey && translationKey !== '') {
        error = locale.getMsg(translationKey);
      } else {
        error = locale.getMsg('unauthorized');
      }
    } else {
      error = `${errorResponse.response.status}: ${errorResponse.message}.`;
    }
  } else if (errorResponse.request) {
    error = locale.getMsg('noErrorResponse');
  } else {
    error = locale.getMsg('errorLabel', [errorResponse.message]);
  }
  return error;
}

function profileMiddleware({ dispatch, getState }) {
  return next => async action => {
    if (action.type === OIDC_SESSION_TERMINATED) {
      const date = parseDateUtc(globals.now).format(globals.dateFormats.date);
      await dispatch({
        type: SELECTED_DATE_UPDATE,
        date,
      });
    }
    if (action.type === USER_EXPIRED) {
      await dispatch({
        type: NO_USER,
      });
    }
    if (action.type === USER_FOUND) {
      const currentState = getState();

      if (currentState.global.auth.isFetching) {
        return next(action);
      }

      const { payload } = action;
      const { profile } = payload;
      const isRefreshing = currentState.global.auth.isAuthenticated;
      const user = {
        email: profile.email,
        name: `${profile.given_name} ${profile.family_name}`,
      };

      if (!isRefreshing) {
        await dispatch({
          type: AUTHORIZED,
          user,
        });
      }

      try {
        await dispatch({
          type: LOGIN_PROFILE,
        });

        const token = `${payload.token_type} ${payload.access_token}`;
        const response = await axios({
          url: 'Account/Profile',
          headers: {
            Authorization: token,
          },
        });

        const data = response.data;
        data.token = payload.access_token;

        await dispatch({
          response: data,
          type: isRefreshing ? LOGIN_REFRESH : LOGIN_SUCCESS,
        });
      } catch (error) {
        dispatch({
          message: loginErrorHandling(error),
          type: LOGIN_FAILURE,
        });
      }
    }
    return next(action);
  };
}

export default profileMiddleware;
